<div class="worker-analytics-container">
  @if (isLoading) {
    <div class="loading-container">
      <nb-spinner status="primary" size="medium"></nb-spinner>
      <span>Loading worker analytics...</span>
    </div>
  }

  @if (!isLoading && workerAnalytics.length === 0) {
    <div
      class="no-data-container"
      >
      No worker data available
    </div>
  }

  @if (!isLoading && workerAnalytics.length > 0) {
    <div class="worker-metrics">
      @for (worker of workerAnalytics; track worker) {
        <div
          class="worker-item"
          (click)="onWorkerClick(worker)"
          (keydown.enter)="onWorkerClick(worker)"
          tabindex="0"
          role="button"
      [style.background]="
        'linear-gradient(to right, ' +
        getBlueColorRgba(0.1) +
        ' ' +
        getWorkerPercentage(worker) +
        '%, ' +
        getBlueColorRgba(0.02) +
        ' ' +
        getWorkerPercentage(worker) +
        '%)'
      "
          >
          <div class="employee" style="flex: none; margin-right: 1px">
            <span class="avatar">
              {{ getWorkerInitials(worker.countedByName) }}
            </span>
          </div>
          <div class="worker-info">
            <div class="worker-name-location">
              <div class="worker-name">{{ worker.countedByName || 'Unknown' }}</div>
              <div class="worker-location">
                {{ worker.locationNum || 'Location' }}
              </div>
            </div>
          </div>
          <div class="worker-stats">
            <div class="total-count">
              {{ worker.totalLines }}
            </div>
            <div class="count-label">Lines Counted</div>
          </div>
        </div>
      }
    </div>
  }
</div>
